var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ThemedTextField from 'components/common/ThemedTextField';
import useInput from 'components/common/hooks/useInput';
const QuantityCell = ({ cellValue, onChange, disabled, precision, setRowBusy, }) => {
    const { t } = useTranslation('orders');
    useEffect(() => {
        setRowBusy === null || setRowBusy === void 0 ? void 0 : setRowBusy((busy) => busy.filter((id) => id !== cellValue.id));
    }, [cellValue.value, cellValue.id, cellValue, setRowBusy]);
    const [consumption, setConsumption] = useInput({
        initialState: cellValue === null || cellValue === void 0 ? void 0 : cellValue.value,
        options: {
            reloadOnStateChange: true,
            type: precision === 0 ? 'number' : 'float',
            emptyValue: '',
        },
    });
    const handleConsumptionChange = useCallback((e) => __awaiter(void 0, void 0, void 0, function* () {
        if (typeof setConsumption === 'function') {
            yield (setRowBusy === null || setRowBusy === void 0 ? void 0 : setRowBusy((busy) => [...busy, cellValue.id]));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            setConsumption(e.target.value, (val) => onChange(cellValue === null || cellValue === void 0 ? void 0 : cellValue.id, val || 0));
        }
    }), [cellValue.id, onChange, setConsumption, setRowBusy]);
    return (React.createElement(ThemedTextField, { value: consumption, unit: cellValue.unit, decimalScale: precision || 2, className: "quantity-cell", disabled: disabled, label: t('common:amount'), onChange: handleConsumptionChange, numeric: precision !== 0, hideClearIcon: true }));
};
export default QuantityCell;
